<style>
</style>
<template>
  <v-navigation-drawer
      temporary
      right
      v-model="drawer"
      light
      absolute
      app
      width="300"
  >
    <v-toolbar text class="secondary primary--text">
      <v-list class="pa-0">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-if="!hasCustomer">{{ $t('Neregistrovaný uživatel') }}</v-list-item-title>
            <v-list-item-title v-else>{{ customer.firstName }} {{ customer.lastName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-toolbar>
    <template text v-if="hasCustomer">
      <v-list inset>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">location_on</v-icon>
              </template>
              <span>{{ $t('Kontakt') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ composedContactAddress }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">phone</v-icon>
              </template>
              <span>{{ $t('Telefon') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ customerPhoneNo }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">email</v-icon>
              </template>
              <span>{{ $t('Email') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ customerEmail }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">account_balance_wallet</v-icon>
              </template>
              <span>{{ $t('Stav účtu') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
                v-if="customer.totalCustomerDisplayedCredit !== null && customer.totalCustomerDisplayedCredit !== undefined">
              {{ customer.totalCustomerDisplayedCredit | currency }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">exit_to_app</v-icon>
              </template>
              <span>{{ $t('Poslední vstup') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <router-link to="customer?selected=visits">
                <template v-if="!lastVisit">{{ $t('Bez vstupu') }}</template>
                <template v-else>{{ lastVisit.startTime | moment("D.M.Y") }}
                  <template v-if="daysFromLastVisit === 0">{{ $t('today') }}</template>
                  <template v-else-if="daysFromLastVisit === 1">{{ $t('yesterday') }}</template>
                  <template v-else-if="lastVisit">({{ $t('before') }}&nbsp;{{
                      daysFromLastVisit
                    }}&nbsp;{{ $t('days') }})
                  </template>
                </template>
              </router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="indigo" v-on="on">credit_card</v-icon>
              </template>
              <span>{{ $t('Aktivní karty') }}</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <router-link to="customer?selected=cards">
                <template v-if="validCards.length === 0">{{ $t('Bez aktivní karty') }}</template>
                <template v-else-if="validCards.length === 1">{{ validCards[0].displayedCardNo }}</template>
                <template v-else-if="validCards.length < 5">{{ validCards.length + $t(' aktivní karty') }}</template>
                <template v-else>{{ validCards.length + $t(' aktivních karet') }}</template>
              </router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-divider></v-divider>
    <template v-if="hasCustomer">
      <v-list class="pt-0" dense>
        <v-list-item @click.stop="settingDialog = true">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Nastavení') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!-- dialog pro zmenu hesla -->
      <v-list class="pt-0" dense>
        <v-list-item @click.stop="passwordDialog = true">
          <v-list-item-action>
            <v-icon>lock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Změna hesla') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!-- odhlaseni -->
      <v-list class="pt-0" dense>
        <v-list-item @click="signOut">
          <v-list-item-action>
            <v-icon>fa fa-sign-out-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Odhlásit se') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-else>
      <!-- prihlaseni -->
      <v-list class="pt-0" dense>
        <v-list-item @click="signIn" v-if="!hasCustomer">
          <v-list-item-action>
            <v-icon>fa fa-sign-in-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Přihlásit se') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list class="pt-0" dense>
        <v-list-item @click="newAccount" v-if="!hasCustomer">
          <v-list-item-action>
            <v-icon>fa fa-id-card</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Registrace') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-list class="pt-0" dense>
      <v-list-item @click="instDialog = true">
        <v-list-item-action>
          <v-icon>info</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('O nás') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- customer dialogy -->
    <customer-setting :visible="settingDialog" @close="settingDialog = false; drawer = false"></customer-setting>
    <v-dialog v-model="passwordDialog" max-width="300px">
      <v-card class="background: secondary" pl-2>
        <v-card-title>
          <h3>{{ $t('Změna hesla') }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <setting-password v-model="newPassword" :errorMessage="errorMessage"></setting-password>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="resetPassword()" @click.native="passwordDialog=false">
            {{ $t('Zpět') }}
          </v-btn>
          <v-btn text color="primary" @click="setPassword()" :disabled="!valid || !newPassword">
            {{ $t('Uložit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="instDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <v-col xs="12">
            <div class="headline primary--text" v-if="hasInstitution">{{
                this.institution.institutionDesc
              }}
            </div>
          </v-col>
          <v-col xs="12" grey--text>
            <div>{{ $t('Na našich klientských stránkách si můžete objednat zboží a služby') }}</div>
          </v-col>
        </v-card-title>
        <v-card-text>
          <page-contacts></page-contacts>
          <v-row>
            <v-col xs="12" mt-3>
                            <span>{{ $t('Seznamte se s ') }}<a :href="institutionTaC" target="_blank">{{
                                $t('obchodními podmínkami')
                              }}</a>.</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider light></v-divider>
        <v-col class="text-right">
          <div>{{ $t('klientská zóna') }} {{ 'v' }}{{ packageVersion }}</div>
        </v-col>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'
import CustomerSetting from '@/components/customer-setting.vue'
import SettingPassword from '@gravela/vue-component-library/src/components/setting-password.vue'
import PageContacts from '@/components/page-contacts.vue'

const _ = require('lodash')

export default {
  props: {
    visible: {
      type: Boolean
    }
  },
  mixins: [BasketMixin, CustomerMixin, InstitutionMixin, StorageMixin, TransformMixin],
  components: {
    'customer-setting': CustomerSetting,
    'page-contacts': PageContacts,
    'setting-password': SettingPassword
  },
  data() {
    return {
      settingDialog: false,
      passwordDialog: false,
      instDialog: false,
      newPassword: null,
      valid: true,
      errorMessage: null
    }
  },
  computed: {
    packageVersion: {
      get() {
        return JSON.stringify(require('../../package.json').version).replace(/['"]+/g, '')
      }
    },
    drawer: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    lastVisit() {
      // let vs = this.customerData.visits
      // let lv = null
      // if (vs !== null && vs.length > 0) {
      //   vs = _.sortBy(vs, ['startTime'])
      //   lv = vs[vs.length - 1]
      // }
      // return lv
      return _.maxBy(this.customerData.visits, 'startTime')
    },
    daysFromLastVisit() {
      var diff = -1
      if (this.lastVisit) {
        var today = new Date()
        today.setHours(23, 59, 59, 999)
        diff = Math.round((today - new Date(this.lastVisit.startTime)) / (1000 * 60 * 60 * 24))
      }
      return diff
    }
  },
  methods: {
    resetPassword() {
      this.errorMessage = null
      this.$refs.form.reset()
    },
    setPassword() {
      if (this.newPassword) {
        this.$fetch('my/customers/passwords', {
          method: 'PUT',
          body: JSON.stringify({
            'password': this.$oauth2.b64Encode(this.newPassword)
          })
        })
            .then(() => {
              this.passwordDialog = false
              this.resetPassword()
            }).catch(() => console.log('reset password error'))
      }
    }
  }
}
</script>
